import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { Icon } from "~/features/ui/icon";
import { useNavLayout } from "~/features/app/app-header-v2/context";
import { useNavDrawer } from "~/features/app/app-header-v2/nav-drawer/context";
import { useLocale } from "~/features/i18n/use-locale";
import Menu from "~/public/icons/menu.svg";
type Props = {
  variant?: keyof typeof variants;
};
const variants = {
  transparent: {
    "borderColor": "rgba(255, 255, 255, 0.2)",
    "backgroundColor": "rgba(0, 7, 4, 0.3)",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  solid: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(244 244 249 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 7 4 / var(--tw-text-opacity))"
  },
  highlighted: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "backgroundColor": "var(--white-static)",
    "color": "var(--black-static)"
  }
} as const;
const translations = {
  en: "Menu",
  zh: "菜单",
  ja: "メニュー",
  ko: "메뉴"
} as const;
export function NavHamburger(props: Props & React.ComponentPropsWithRef<"button">) {
  const {
    variant,
    ...rest
  } = props;
  const {
    navTheme,
    isPageHighlighted
  } = useNavLayout();
  const surface = isPageHighlighted ? "highlighted" : variant || navTheme;
  const {
    setIsDrawerOpen
  } = useNavDrawer();
  const locale = useLocale();
  return <_StyledButton onClick={() => setIsDrawerOpen(true)} aria-label="Open navigation menu" {...rest} $_css={[{
    "pointerEvents": "auto",
    "position": "relative",
    "zIndex": "100",
    "flexShrink": "0",
    "borderBottomWidth": "1px",
    "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
    "transitionDuration": "250ms",
    "transitionTimingFunction": "ease-in-out"
  }, {
    "@media (hover: hover)": {
      "&:hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
        "--tw-text-opacity": "1",
        "color": "rgb(255 255 255 / var(--tw-text-opacity))"
      }
    }
  }, {
    "@media (hover: none)": {
      "&:active": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
        "--tw-text-opacity": "1",
        "color": "rgb(255 255 255 / var(--tw-text-opacity))"
      }
    }
  }, variants[surface]]}>
      <_StyledDiv>
        <Icon icon={Menu} />
        <_StyledDiv2>{translations[locale]}</_StyledDiv2>
      </_StyledDiv>
    </_StyledButton>;
}
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-sf-ep3aw5-0"
})`${p => p.$_css}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-ep3aw5-1"
})({
  "display": "flex",
  "height": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "columnGap": "1.6rem",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem",
  "@media (min-width: 1024px)": {
    "columnGap": "2.4rem",
    "paddingLeft": "2.4rem",
    "paddingRight": "2.4rem"
  }
});
var _StyledDiv2 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "nav-hamburger___StyledDiv2",
  componentId: "sc-g4df6k-0"
})({
  "pointerEvents": "none",
  "fontSize": "1.6rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.016rem",
  "fontWeight": "400"
});